import { MenuData } from "../components/input/CustomSelect";

export const ENERGY_USAGE_BOUNDARY: MenuData[] = [
  {
    value: "inbound-usage",
    nameEN: "Inbound Usage",
    nameTH: "การใช้งานขาเข้า",
  },
  {
    value: "resell-to-outbound",
    nameEN: "Resell to outbound",
    nameTH: "ขายต่อไปยังต่างประเทศ",
  },
];

export const WASTEWATER_INDUSTRY_TYPE: MenuData[] = [
  {
    value: "Alcohol Distilling",
    nameEN: "Alcohol Distilling",
    nameTH: "การกลั่นแอลกอฮอล์",
  },
  { value: "Beer", nameEN: "Beer", nameTH: "เบียร์" },
  { value: "Coffee", nameEN: "Coffee", nameTH: "กาแฟ" },
  { value: "Dairy Products", nameEN: "Dairy Products", nameTH: "ผลิตภัณฑ์นม" },
  {
    value: "Seafood Processing",
    nameEN: "Seafood Processing",
    nameTH: "การแปรรูปอาหารทะเล",
  },
  {
    value: "Meat Processing",
    nameEN: "Meat Processing",
    nameTH: "การแปรรูปเนื้อสัตว์",
  },
  {
    value: "Organic Chemistry",
    nameEN: "Organic Chemistry",
    nameTH: "เคมีอินทรีย์",
  },
  { value: "Oil Refinery", nameEN: "Oil Refinery", nameTH: "โรงกลั่นน้ำมัน" },
  {
    value: "Plastic and Polyethylene Resin",
    nameEN: "Plastic and Polyethylene Resin",
    nameTH: "พลาสติกและเรซินโพลีเอทิลีน",
  },
  {
    value: "Paper and Pulp",
    nameEN: "Paper and Pulp",
    nameTH: "กระดาษและเยื่อกระดาษ",
  },
  {
    value: "Flour Products",
    nameEN: "Flour Products",
    nameTH: "ผลิตภัณฑ์แป้ง",
  },
  { value: "Fruit Juice", nameEN: "Fruit Juice", nameTH: "น้ำผลไม้" },
  {
    value: "Wine and Vinegar",
    nameEN: "Wine and Vinegar",
    nameTH: "ไวน์และน้ำส้มสายชู",
  },
];

export const PURCHASE_TYPE: MenuData[] = [
  {
    value: "Purchased goods and services",
    nameEN: "Purchased goods and services",
    nameTH: "สินค้าซื้อและบริการ",
  },
  { value: "Capital goods", nameEN: "Capital goods", nameTH: "สินค้าทุน" },
];

export const WASTE_SOURCE_CATEGORY: MenuData[] = [
  { value: "Self Operate", nameEN: "Self Operate", nameTH: "ดำเนินการเอง" },
  {
    value: "Outsourcing : Waste Generated in Operations",
    nameEN: "Outsourcing : Waste Generated in Operations",
    nameTH: "การจ้างงานภายนอก: ของเสียที่เกิดจากการดำเนินงาน",
  },
  {
    value: "Outsourcing : End of Life Treatment of Sold Product",
    nameEN: "Outsourcing : End of Life Treatment of Sold Product",
    nameTH:
      "การจ้างงานภายนอก: การจัดการเมื่อหมดอายุการใช้งานของผลิตภัณฑ์ที่ขาย",
  },
];

export const TRIP_TYPE: MenuData[] = [
  { value: "One-way", nameEN: "One-way", nameTH: "เที่ยวเดียว" },
  { value: "Round trip", nameEN: "Round trip", nameTH: "ไปกลับ" },
];

export const SEPTIC_TANK_TYPE: MenuData[] = [
  { value: "Standard", nameEN: "Standard", nameTH: "มาตรฐาน" },
];

export const GOOD_TYPE: MenuData[] = [
  {
    value: "Goods Purchased",
    nameEN: "Goods Purchased",
    nameTH: "สินค้าที่ซื้อ",
  },
  { value: "Product Sold", nameEN: "Product Sold", nameTH: "สินค้าที่ขาย" },
  { value: "Waste", nameEN: "Waste", nameTH: "ของเสีย" },
];

export const FERTILIZER_TYPE: MenuData[] = [
  { value: "Standard", nameEN: "Standard", nameTH: "มาตรฐาน" },
];

export const INDUSTRY_TYPE: MenuData[] = [
  { nameEN: "Manufacturing", nameTH: "ธุรกิจการผลิต", value: "Manufacturing" },
  { nameEN: "Service Business", nameTH: "ธุรกิจบริการ", value: "Service Business" },
  { nameEN: "Retail & Wholesale", nameTH: "ธุรกิจค้าปลีก/ค้าส่ง", value: "Retail & Wholesale" },
  { nameEN: "Finance & Investment", nameTH: "ธุรกิจการเงินและการลงทุน", value: "Finance & Investment" },
  { nameEN: "Technology Business", nameTH: "ธุรกิจเทคโนโลยี", value: "Technology Business" },
];
